import { combineReducers } from 'redux';
import cart from './slices/cartSlice';
import cartVariant from './slices/cartVariantSlice';
import inputFocus from './slices/inputFocusSlice';

const rootReducer = combineReducers({
  cart,
  cartVariant,
  inputFocus,
});

export default rootReducer;
